export default __webpack_public_path__ + "static/media/cs2.76b15191.JPG";